import React from 'react';

import Checkbox from 'antd/lib/checkbox';

import Text, { FontFamilyVariant, TextType } from '@components/WFThinkDesign/Typography';

import './styles.less';

export const CheckBox = (props: {
  label: string;
  isChecked: boolean;
  onPress: () => void;
  className: string;
  disabled?: boolean;
}) => {
  const { label, isChecked, onPress, className, disabled } = props;
  
  return (
    <div className={`wf_checkbox ${className}`}>
      <Checkbox disabled={disabled} checked={isChecked} onClick={onPress}>{label}</Checkbox>
    </div>
  );
};
